import React from 'react';

import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import TextField from '@base/Inputs/Text'

const useStyles = makeStyles(
    (theme) => (
        {
            wrapper: {
                padding: theme.spacing(2)
            },
            title: {
                color: "#333",
                fontSize: 24,
            },
            formControl: {
                margin: theme.spacing(2, 0),
                width: '100%',
            }
        }
    )
);


export const FormularioTriagem = (props) => {

    const meuEstilo = useStyles();

    return (
        <>
            <Paper className={meuEstilo.wrapper} elevation={0} spacing={2}>

                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={2} >
                        <TextField
                            disabled={true}
                            label="Número do Objeto Postal"
                            value={props.numeroObjetoPostal} helperText="Exemplo de Formato: XX000000000XX" />
                    </Grid>

                    <Grid item sm={2}>
                        <TextField
                            disabled={props.possuiCaixaAssociado}
                            required={!props.possuiCaixaAssociado}
                            label='Caixa'
                            inputProps={{
								maxLength: 4
							}}
                            helperText="Exemplo de Formato: XXXX"
                            value={props.caixa}
                            onChange={(e) => {
                                    props.handleCaixa(e.target.value)


                            }}
                        />
                    </Grid>
                </Grid>

                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={2}>
                        <TextField
                            autoFocus
                            required={!props.semDataPostagem}
                            disabled={props.readonly || props.semDataPostagem}
                            label="Dia da Postagem"
                            value={props.diaPostagem}
                            onChange={(e) => {
                                if (e.target.value.length === 2) {
                                    props.handleDiaPostagem(e.target.value)
                                    document.getElementById("mesPostagemRef").focus();
                                } else if (e.target.value.length < 2) {
                                    props.handleDiaPostagem(e.target.value);
                                }


                            }}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            id="mesPostagemRef"
                            required={!props.semDataPostagem}
                            disabled={props.readonly || props.semDataPostagem}
                            label="Mês da Postagem"
                            value={props.mesPostagem}
                            onChange={(e) => {
                                if (e.target.value.length === 2) {

                                    if (parseInt(e.target.value) > 12) {
                                        props.handleMesPostagem("");
                                    } else {
                                        props.handleMesPostagem(e.target.value)
                                    }

                                } else if (e.target.value.length < 2) {
                                    props.handleMesPostagem(e.target.value);
                                }
                            }}
                        />
                    </Grid>
                    
                    { (props.diaPostagem === "" && props.mesPostagem === "") &&
                        <Grid item sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={props.semDataPostagem}
                                        value={props.semDataPostagem}
                                        onChange={(e) => props.handleSemDataPostagem(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Sem Data de Postagem no Objeto Postal"
                            />
                        </Grid>
                    }
                </Grid>

                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.materialDanificado}
                                    value={props.materialDanificado}
                                    onChange={(e) => {
                                        props.handleMaterialDanificado(e.target.checked);
                                    }}
                                    color="primary"
                                />
                            }
                            label="Material Danificado"
                        />
                    </Grid>
                </Grid>

                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.conteudoNaoPrevisto}
                                    value={props.conteudoNaoPrevisto}
                                    onChange={(e) => {
                                        props.handleConteudoNaoPrevisto(e.target.checked);
                                    }}
                                    color="primary"
                                />
                            }
                            label="Outros Documentos"
                        />
                    </Grid>
                </Grid>

                <Grid alignItems="center" container spacing={2}>
                    <Grid item sm={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.conteudoNaoRelacionadoObmep}
                                    value={props.conteudoNaoRelacionadoObmep}
                                    onChange={(e) => {
                                        props.handleConteudoNaoRelacionadoObmep(e.target.checked);
                                    }}
                                    color="primary"
                                />
                            }
                            label="Conteúdo Não Relacionado à OBMEP"
                        />
                    </Grid>
                </Grid>
            </Paper>
            <br />
        </>
    );
}

export default FormularioTriagem;
